module.exports = __webpack_public_path__ + "static/CA-logo-header-bc209f1487c0d31501a8cf995806a09f.svg";